import React, { useEffect, useState, useMemo } from "react";
import "./ChartSurfaceDark.css";
import "./ChartFilterDark.css";
import "./Barchart.css";
import "./ChartCard.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
  ResponsiveContainer,
  Brush,
  ReferenceArea,
} from "recharts";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { getProducts } from "../../../actions/userActions/productAction";
import { getCallAveragProduct } from "../../../actions/userActions/callAveragePro";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, IconButton, Menu, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { Tooltip as MaterialTooltip } from "@mui/material";
import ApplyButton from "../buttons/ApplyButton";
import ResetButton from "../buttons/ResetButton";
import { Check, Package, User, CalendarDays, Info, Search, X } from "lucide-react";
import BodyMediumRegular from "../../designSystem/BodyMediumRegular";
import MultiSelect from "../../designSystem/MultiSelect";
import SingleSelect from "../../designSystem/SingleSelect";
import BodySmallRegular from "../../designSystem/BodySmallRegular";
import LineChartTooltip from "./LineChartTooltip";
import LineChartLegend from "./LineChartLegend";
import GranularitySelect from "./GranularitySelect";
import { getSeriesColor } from "./chartPalette";
import {
  DATE_KEY,
  EMPTY_SUMMARY,
  summarise,
  rankSeries,
  bucketByTime,
} from "./chartData";
import useIsDarkTheme from "../../../hooks/useIsDarkTheme";
import { getSubOrdinates } from "../../../actions/userActions/tasks/taskAction";
import { t } from "../../../locales/translate";
const SHOW_ALL = "all";

export function Barchart({ chartSummaryData, loading, onChangeCallProduct }) {
  const [appliedFilters, setAppliedFilters] = useState([]);
  const buttonLabels = {
    "today": "Today",
    "this week": "Week",
    "this month": "Month",
    "this year": "Year",
    "custom": `${t("custom")}`,
  };
  function choosefilters(filters) {
    setAppliedFilters(filters);
  }
  const productName = chartSummaryData.length > 0 ? chartSummaryData[0].productName : null;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [customDate, setCustomDate] = useState(false);
  const [formError, setFormError] = useState({});
  const currentDate = moment();
  const dispatch = useDispatch();
  const [Filters, setFilters] = useState({
    product: 0,
    employeeIds: [],
    fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
    toDate: moment(currentDate).format("YYYY-MM-DD"),
  });
  const [selected, setSelected] = useState({
    product: "",
    employeeIds: [],
    fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
    toDate: moment(currentDate).format("YYYY-MM-DD"),
  });
  const user = JSON.parse(localStorage.getItem("user"));
  const employeeId =
    user.result[0] !== undefined ? user.result[0].user.id : false
  const [employeesName, setEmployeesName] = useState([]);
  const products = useSelector((state) => state.products_reducer.products);
  const employees = useSelector((state) => state.tasks_reducer.subOrdinates);
  const employeesLoading = useSelector((state) => state.tasks_reducer.loading);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);
  const [cachedProductOptions, setCachedProductOptions] = useState([]);

  useEffect(() => {
    if (products && products !== "isLoading" && products.result?.length) {
      setCachedProductOptions(
        products.result
          .filter((product) => product.active)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((product) => ({
            value: product.id,
            label: product.name,
          }))
      );
    }
  }, [products]);


  const setEmployeeNames = (array) => {
    setEmployeesName(array);
  };
  useEffect(() => {

    let data = [];
    employees &&
      employees !== "isLoading" &&
      employees.map((row) => {
        appliedFilters.map((row2) => {
          if (row.id == row2) {
            data.push(row.firstName + " " + row.lastName);
          }
        });
      });

    setEmployeeNames(data);
  }, [employees, appliedFilters]);
  const [uniqueEmployees, setUniqueEmployees] = useState([]);
  const callAvgProduct = useSelector(
    (state) => state.call_avg_pro_reducer.callAvgPro
  );

  /* One row per day the API reported, before any bucketing. */
  const [dailyRows, setDailyRows] = useState([]);
  const [summary, setSummary] = useState(EMPTY_SUMMARY);
  const isDark = useIsDarkTheme();
  /* Employees the reader has clicked off in the legend. A view concern only -
     the data is untouched. */
  const [hiddenSeries, setHiddenSeries] = useState([]);
  /* "auto" | "day" | "week" | "month" | "year" */
  const [granularity, setGranularity] = useState("auto");
  const [appliedEmployees, setAppliedEmployees] = useState([]);
  const [appliedPreset, setAppliedPreset] = useState("this week");
  /* The visible window, as indices into the plotted rows. null = show all. */
  const [zoom, setZoom] = useState(null);
  /* The in-progress drag, kept apart from the committed window so an
     abandoned drag never changes what is shown. */
  const [dragSelection, setDragSelection] = useState(null);
  useEffect(() => {
    const sourceData =
      callAvgProduct && callAvgProduct !== "isLoading" && callAvgProduct.length > 0
        ? callAvgProduct
        : chartSummaryData || [];
    if (sourceData.length > 0) {
      const uniqueEmployees = [];
      const groupedData = sourceData.reduce((result, item) => {
        const date = moment(item.dateTime).format("D MMM, YY");
        const key = `${date}`;

        if (!result[key]) {
          result[key] = { date };
        }
        if (!uniqueEmployees.includes(item.employeeName)) {
          uniqueEmployees.push(item.employeeName);
        }
        result[key][item.employeeName] = (result[key][item.employeeName] || 0) + item.calls;

        return result;
      }, {});

      const employeeNames = new Set();
      Object.values(groupedData).forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== "date") {
            employeeNames.add(key);
          }
        });
      });

      const outputData = Object.values(groupedData)
        .map((item) => {
          const formattedItem = { date: item.date };
          employeeNames.forEach((employeeName) => {
            formattedItem[employeeName] = item[employeeName] || 0;
          });
          return formattedItem;
        })
        .sort((a, b) => moment(a.date, "D MMM, YY").toDate() - moment(b.date, "D MMM, YY").toDate());

      const allEmployees = Array.from(employeeNames);
      /* Summarise the raw days first - the strip should report the product,
         not whatever resolution the chart ends up drawn at. */
      setSummary(summarise(outputData, allEmployees));
      setDailyRows(outputData);
      setUniqueEmployees(rankSeries(outputData, allEmployees));
    } else {
      /* A filter that matches nothing used to leave the previous product's
         chart on screen, which read as if the filter had done nothing. */
      setDailyRows([]);
      setUniqueEmployees([]);
      setSummary(EMPTY_SUMMARY);
    }
  }, [callAvgProduct, chartSummaryData]);

  /* Bucketing is kept out of the fetch effect so switching granularity
     redraws from the rows already in hand instead of going back to the API. */
  const { rows: data, unit: bucketUnit } = useMemo(
    () =>
      bucketByTime(
        dailyRows,
        uniqueEmployees,
        granularity === "auto" ? null : granularity
      ),
    [dailyRows, uniqueEmployees, granularity]
  );

  /* Colours come from the validated series palette and are keyed on the
     employee name, so an employee looks the same on every reload and after a
     filter changes how many bars are on screen. */
  const employeeColors = useMemo(
    () =>
      uniqueEmployees.reduce((map, employee) => {
        map[employee] = getSeriesColor(employee, isDark, "employees");
        return map;
      }, {}),
    [uniqueEmployees, isDark]
  );

  const toggleSeries = (employee) => {
    setHiddenSeries((prev) =>
      prev.includes(employee)
        ? prev.filter((item) => item !== employee)
        : [...prev, employee]
    );
  };

  /* Drop hidden employees that are no longer part of the result set. */
  useEffect(() => {
    setHiddenSeries((prev) =>
      prev.filter((employee) => uniqueEmployees.includes(employee))
    );
  }, [uniqueEmployees]);

  /* New rows or a new resolution means both the saved window and an earlier
     "show all" refer to a chart that no longer exists - back to the default
     window for whatever is on screen now. */
  useEffect(() => {
    /* Bail out when there is nothing to reset, so a granularity change
       costs one render instead of two. */
    setZoom((prev) => (prev === null ? prev : null));
    setDragSelection((prev) => (prev === null ? prev : null));
  }, [dailyRows, granularity]);
  //
  const productBody = {
    filter: {
      textSearch: "",
    },
    pageNumber: -1,
    pageSize: 0,
  };
  useEffect(() => {
    if (open) {
      setIsLoadingProducts(true);
      dispatch(getProducts(productBody))
        .catch(error => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setIsLoadingProducts(false);
        });
      dispatch(getSubOrdinates(employeeId, -1, 0, ""));
    }
  }, [open]);
  const handleApply = () => {
    if (validateForm()) {
      const body = {
        productFilters: {
          product: Filters.product ? Filters.product : 0,
          employeeIds: Filters.employeeIds ? Filters.employeeIds : [0],
        },
        startTime: Filters.fromDate ? Filters.fromDate : new Date().toISOString(),
        endTime: Filters.toDate ? Filters.toDate : new Date().toISOString(),
      };
      onChangeCallProduct(body)
      dispatch(getCallAveragProduct(body));
      choosefilters(Filters.employeeIds);
      setAppliedEmployees(Filters.employeeIds || []);
      setAppliedPreset(selectedButton);
      handleClose();
    }
  };

  const handleReset = () => {
    setSelected({
      employeeIds: [],
      product: "",
      fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
      toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    setFilters({
      employeeIds: [],
      product: 0,
      fromDate: moment(currentDate).subtract(7, "days").format("YYYY-MM-DD"),
      toDate: moment(currentDate).format("YYYY-MM-DD"),
    });
    setSelectedButton("this week");
  }
  //
  const validateForm = () => {
    let errors = {};
    let isValid = true;
    if (!Filters.fromDate) {
      errors.fromDate = "From date is required.";
      isValid = false;
    }
    if (!Filters.toDate) {
      errors.toDate = "To date is required.";
      isValid = false;
    }

    setFormError(errors);
    return isValid;
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedButton, setSelectedButton] = useState("this week");
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event) => {
      const menuPaper = document.querySelector('.MuiMenu-paper, .MuiPopover-paper');
      
      // Don't close if clicking inside any MUI Paper (calendar, picker, dialog, etc.)
      const isInsideMuiPaper = event.target.closest('.MuiPaper-root') !== null;
      if (isInsideMuiPaper) return;
      
      if (menuPaper && !menuPaper.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    return () => document.removeEventListener('mousedown', handleClickOutside, true);
  }, [open]);
  const handleToggleSelection = (event, newSelection) => {
    if (newSelection === "this week") {
      setCustomDate(false);
      const fromDate = moment().startOf("week").format("YYYY-MM-DD");
      const toDate = moment().endOf("week").format("YYYY-MM-DD");
      setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
    } else if (newSelection === "today") {
      setCustomDate(false);
      const currentDate = moment().format("YYYY-MM-DD");
      setSelected(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: currentDate, toDate: currentDate }));
    } else if (newSelection === "yesterday") {
      setCustomDate(false);
      const yesterdayDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      setSelected(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: yesterdayDate, toDate: yesterdayDate }));
    } else if (newSelection === "last 30 days") {
      setCustomDate(false);
      const fromDate = moment().subtract(29, "days").toDate();
      const toDate = moment().toDate();
      setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
    } else if (newSelection === "this month") {
      setCustomDate(false);
      const fromDate = moment().startOf("month").toDate();
      const toDate = moment().endOf("month").toDate();
      setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
    } else if (newSelection === "last month") {
      setCustomDate(false);
      const fromDate = moment().subtract(1, "month").startOf("month").toDate();
      const toDate = moment().subtract(1, "month").endOf("month").toDate();
      setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
    } else if (newSelection === "this year") {
      setCustomDate(false);
      const fromDate = moment().startOf("year").toDate();
      const toDate = moment().endOf("year").toDate();
      setSelected(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
      setFilters(prevValues => ({ ...prevValues, fromDate: fromDate, toDate: toDate }));
    } else if (newSelection === "custom") {
      setCustomDate(true);
      setSelected(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
      setFilters(prevValues => ({ ...prevValues, fromDate: "", toDate: "" }));
    }

    setSelectedButton(newSelection);
  };
  const handleProductChange = (event) => {
    setSelected(prevValues => ({
      ...prevValues,
      product: event.value,
    }));
    setFilters(prevValues => ({
      ...prevValues,
      product: event.value,
    }));
  };
  const handleEmployeesChange = (selectedEmployees) => {

    setSelected(prevValues => ({
      ...prevValues,
      employeeIds: selectedEmployees,
    }));

    setFilters(prevValues => ({
      ...prevValues,
      employeeIds: selectedEmployees,
    }));
  };
  const handleFromDateChange = (date) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    setSelected(prevValues => ({
      ...prevValues,
      fromDate: formattedDate,
    }));
    setFilters(prevValues => ({
      ...prevValues,
      fromDate: formattedDate,
    }));
  };
  const handleToDateChange = (date) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    setSelected(prevValues => ({
      ...prevValues,
      toDate: formattedDate,
    }));
    setFilters(prevValues => ({
      ...prevValues,
      toDate: formattedDate,
    }));
  };
  const getProductOptions = () => {
    if (products && products !== "isLoading" && products.result?.length) {
      return products.result
        .filter((product) => product.active)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((product) => ({
          value: product.id,
          label: product.name,
        }));
    }
    return cachedProductOptions;
  };
  const productOptions = getProductOptions();
  const isProductFieldLoading = isLoadingProducts && productOptions.length === 0;

  /* ---- Card chrome, matching the call-average-by-employee card --------- */

  const isChartLoading = callAvgProduct === "isLoading" || loading;
  const hasPlottedData = !isChartLoading && data.length > 0;

  const shownProductName =
    (callAvgProduct &&
      callAvgProduct !== "isLoading" &&
      callAvgProduct[0]?.productName) ||
    productName;

  /* Taken from the data that came back, not from the filter panel: the panel
     holds what the user is typing, which is not necessarily what is drawn. */
  const rangeLabel = summary.rangeLabel;

  const employeeScopeLabel = appliedEmployees.length
    ? `${appliedEmployees.length} ${t("employees")}`
    : t("allEmployees");

  const hasActiveFilters =
    appliedEmployees.length > 0 || Boolean(Filters.product);

  const presetLabel = {
    today: t("today"),
    "this week": t("week"),
    "this month": t("month"),
    "this year": t("year"),
    custom: t("custom"),
  }[appliedPreset];

  const GRANULARITY_OPTIONS = [
    { value: "auto", label: t("auto") },
    { value: "day", label: t("daily") },
    { value: "week", label: t("weekly") },
    { value: "month", label: t("monthly") },
    { value: "year", label: t("yearly") },
  ];
  const unitLabels = {
    day: t("daily"),
    week: t("weekly"),
    month: t("monthly"),
    year: t("yearly"),
  };
  const granularityLabel = unitLabels[bucketUnit] || t("daily");

  /* Stacked segments are separated by a hairline in the surface colour. */
  const surfaceColor = isDark ? "#1C3041" : "#FFFFFF";

  /* ---- The visible window --------------------------------------------- */

  /* A zoom window is a pair of indices, and those only mean anything against
     the exact rows they were taken from: months 5-10 is a valid pair for 547
     daily rows too, it just points at six days instead. So the window carries
     the resolution and row count it belongs to and is dropped as soon as
     either changes. */
  /* Past about sixty bars two things go wrong at once: each bar is down to a
     few pixels, and a re-render costs enough that dragging the selection
     stutters (measured: 60 bars ~62ms a frame, 300 bars ~297ms). So a long
     range opens on its most recent stretch instead of all of it. Nothing is
     hidden - the brush still spans everything and "show all" is one click. */
  const MAX_COMFORTABLE_BARS = 60;

  const defaultWindow =
    data.length > MAX_COMFORTABLE_BARS
      ? {
          startIndex: data.length - MAX_COMFORTABLE_BARS,
          endIndex: data.length - 1,
        }
      : null;

  const zoomWindow =
    zoom === SHOW_ALL
      ? null
      : zoom && zoom.unit === bucketUnit && zoom.length === data.length
      ? zoom
      : defaultWindow;

  const windowFor = (startIndex, endIndex) => ({
    startIndex,
    endIndex,
    unit: bucketUnit,
    length: data.length,
  });

  const isZoomed = zoomWindow !== null;

  /* How many bars are actually on screen - the whole set, or just the
     brushed window. */
  const visibleCount = zoomWindow
    ? zoomWindow.endIndex - zoomWindow.startIndex + 1
    : data.length;

  /* At a daily resolution over a long range a bar is about two pixels wide,
     and a one-pixel separator on each side eats the whole thing - the chart
     went blank. Below that width the bars sit flush and the gap between
     dates does the separating. */
  const barStrokeWidth = visibleCount <= 60 ? 1 : 0;

  const handleZoomStart = (event) => {
    if (!event || event.activeTooltipIndex == null) return;
    setDragSelection({
      startIndex: event.activeTooltipIndex,
      endIndex: event.activeTooltipIndex,
      left: event.activeLabel,
      right: event.activeLabel,
    });
  };

  const handleZoomMove = (event) => {
    if (!dragSelection || !event || event.activeTooltipIndex == null) return;
    /* A mouse move fires far more often than the selection actually changes.
       Re-rendering the whole plot on every pixel is what made dragging feel
       heavy, so nothing happens until the pointer crosses into a new
       bucket. */
    if (event.activeTooltipIndex === dragSelection.endIndex) return;
    setDragSelection((prev) => ({
      ...prev,
      endIndex: event.activeTooltipIndex,
      right: event.activeLabel,
    }));
  };

  const handleZoomEnd = () => {
    if (!dragSelection) return;
    const from = Math.min(dragSelection.startIndex, dragSelection.endIndex);
    const to = Math.max(dragSelection.startIndex, dragSelection.endIndex);
    /* A click is not a drag. */
    if (to - from >= 1) {
      setZoom(windowFor(from, to));
    }
    setDragSelection(null);
  };

  /* An explicit "show everything" - distinct from null, which means "no
     choice made yet" and falls back to the default window. */
  const resetZoom = () => {
    setZoom(SHOW_ALL);
    setDragSelection(null);
  };

  /* Built here rather than taken from the chart, so the legend sits below the
     plot instead of eating into it. */
  const legendPayload = uniqueEmployees.map((employee) => ({
    dataKey: employee,
    value: employee,
    color: employeeColors[employee],
  }));
  const getEmployeeOptions = () => {
    return (
      employees &&
      employees !== "isLoading" &&
      employees?.length !== 0 &&
      employees
        .sort((a, b) => {
          const firstNameComparison = a.firstName.localeCompare(b.firstName);
          return firstNameComparison !== 0
            ? firstNameComparison
            : a.lastName.localeCompare(b.lastName);
        })
        .map((employee) => ({
          value: employee.id,
          label: `${employee.firstName} ${employee.lastName}`,
        }))
    ) || [];
  };
  return (
  <div className="chart-container bar-chart-container overlay-wrapper lc-card">
    <div>   <div>
        <div className="lc-card__header">
          <div className="lc-card__titles">
            <div className="lc-card__title-row">
              <Package size={18} aria-hidden="true" />
              <h3 className="lc-card__title">{t("callAverageByProduct")}</h3>
              <MaterialTooltip
                title={`${t("callAverageProductHelp")} ${t("dragToZoom")}.`}
                arrow
                enterTouchDelay={0}
                placement="top"
              >
                <span className="lc-card__info" tabIndex={0} role="note">
                  <Info size={14} aria-hidden="true" />
                </span>
              </MaterialTooltip>
            </div>
            <p className="lc-card__subtitle">{t("callsOverTimeByEmployee")}</p>
          </div>
          <div className="lc-card__filter-wrap">
            <MaterialTooltip title={t("applyFilters")} arrow enterDelay={500} placement="bottom">
              <button
                type="button"
                className={`lc-card__filter-btn${open ? " is-active" : ""}`}
                onClick={handleClick}
                aria-label={t("applyFilters")}
                aria-haspopup="true"
                aria-expanded={open}
              >
                <FilterAltOutlinedIcon fontSize="small" />
              </button>
            </MaterialTooltip>
            {hasActiveFilters && <span className="lc-card__filter-dot" />}
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              PaperProps={{
                style: {
                  width: "640px",
                  borderRadius: "4px",
                  background: "#FFFFFF",
                  boxShadow: "0px 11px 15px -7px #00000033",
                },
              }}
            >
              <div className="row" style={{
                padding: "16px 24px 16px 24px",
                justify: "space-between",
                display: "flex",
                gap: "24px"
              }}>
                <div className="col-12 d-flex ml-2">
                  <BodyMediumRegular text={t("applyFilters")} />
                  <MaterialTooltip title="Close Filter" arrow>
                    <CloseIcon style={{ marginLeft: "auto", cursor: "pointer" }} onClick={handleClose} />
                  </MaterialTooltip>
                </div>
              </div>
              <div className="row" style={{
                gap: "24px",
                borderBottom: "1px solid #0000001F",
                padding: "24px 16px 24px 16px",
                alignItems: "center"
              }}>
                <div className="row" style={{ gap: "16px" }}>
                  <div className="col-12 d-flex justify-content-center align-items-center" style={{ height: "48px" }}>
                    <ToggleButtonGroup
                      exclusive
                      value={selectedButton}
                      onChange={handleToggleSelection}
                      aria-label="button group"
                      style={{
                        width: "100%",
                        height: "40px",
                        gap: "12px",
                        borderRadius: "6px",
                        padding: "4px 8px",
                        backgroundColor: "#f9fafb",
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                      }}
                    >

                      {["today", "this week", "this month", "this year", "custom"].map((value) => (
                        <ToggleButton
                          key={value}
                          value={value}
                          style={{
                            minWidth: "34px",
                            height: "34px",
                            padding: "4px 12px",
                            borderRadius: "6px",
                            textTransform: "none",
                            border: "none",
                            backgroundColor: selectedButton === value ? "#FFFFFF" : "inherit",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <BodyMediumRegular text={buttonLabels[value]} />
                        </ToggleButton>
                      ))}

                    </ToggleButtonGroup>
                  </div>
                  <div className="col-12 d-flex" style={{
                    height: "56px",
                  }}>
                    <div className="col-6">
                      <div style={{ marginBottom: "6px" }}>
                        <BodySmallRegular text={t("from")} />
                      </div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker

                          valueType="date"
                          value={selected.fromDate && selected.fromDate.length != 0 ? dayjs(selected.fromDate) : null}
                          onChange={handleFromDateChange}
                          disabled={!customDate}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                          sx={{
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                              padding: "0",
                              boxSizing: "border-box",
                              backgroundColor: "transparent",
                              border: "1px solid #E0E0E0",
                              borderRadius: "60px",
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                            },
                            "& .MuiInputBase-input": {
                              height: "32px",
                              padding: "0px 8px",
                              fontSize: "14px",
                            },
                            "& .MuiIconButton-root": {
                              padding: "20px",
                            },
                          }}
                        />
                      </LocalizationProvider>
                      {formError.fromDate && (
                        <span style={{ color: "red" }}>{formError.fromDate}</span>
                      )}
                    </div>
                    <div className="col-6">
                      <div style={{ marginBottom: "6px" }}>
                        <BodySmallRegular text={t("to")} />
                      </div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker

                          valueType="date"
                          value={selected.toDate && selected.toDate.length != 0 ? dayjs(selected.toDate) : null}
                          onChange={handleToDateChange}
                          disabled={!customDate}
                          renderInput={(params) => <TextField fullWidth {...params} />}
                          sx={{
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              height: "40px",
                              padding: "0",
                              boxSizing: "border-box",
                              backgroundColor: "transparent",
                              border: "1px solid #E0E0E0",
                              borderRadius: "60px",
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                            },
                            "& .MuiInputBase-input": {
                              height: "32px",
                              padding: "0px 8px",
                              fontSize: "14px",
                            },
                            "& .MuiIconButton-root": {
                              padding: "20px",
                            },
                          }}
                        />
                      </LocalizationProvider>
                      {formError.toDate && (
                        <span style={{ color: "red" }}>{formError.toDate}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row" style={{ gap: "16px" }}>
                  <div className="col-12 d-flex" >
                    <div className="col-6">
                      <SingleSelect
                        label={t("product")}
                        isSearchable
                        secondaryLabel
                        iconEnd
                        onChange={handleProductChange}
                        value={selected.product}
                        placeholder={isProductFieldLoading ? "Loading Products..." : t("product")}
                        options={productOptions}
                        isLoading={isProductFieldLoading}
                      />
                    </div>
                    <div className="col-6">
                      <MultiSelect
                        isSearchable
                        onChange={handleEmployeesChange}
                        value={selected?.employeeIds || []}
                        label={t("employee")}
                        options={getEmployeeOptions()}
                        isLoading={employeesLoading}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mr-4" style={{
                padding: "16px 24px 16px 24px",
                gap: "8px",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexWrap: "nowrap"
              }}>
                 <button
                type="submit"
                className="primary-button"
                disabled={false}
                onClick={handleApply}
                  style={{ width: "78px", minWidth: "78px", maxWidth: "78px", flex: "0 0 78px" }}
              >
                <span className="button-content">
                  <p className="button-text save">{t("apply")}</p>
                </span>
              </button>
              <button
                className="cancel-button"
                type="button"
                onClick={handleReset}
                style={{ width: "88px", minWidth: "88px", maxWidth: "88px", flex: "0 0 88px" }}

              >
                <span className="button-content">
                 <p className="button-text">{t("reset")}</p>
                </span>
              </button>
              </div>

            </Menu>
          </div>
        </div>

        {/* What is on screen right now: which product, over which dates,
            across how many employees. */}
        <div className="lc-scope">
          {shownProductName && (
            <span className="lc-scope__person">
              <Package size={15} aria-hidden="true" />
              {shownProductName}
            </span>
          )}
          {rangeLabel && (
            <span className="lc-chip">
              <CalendarDays aria-hidden="true" />
              {rangeLabel}
              {presetLabel && (
                <span className="lc-chip__preset">{presetLabel}</span>
              )}
            </span>
          )}
          <span className="lc-chip">
            <User aria-hidden="true" />
            {employeeScopeLabel}
          </span>
          {hasPlottedData && (
            <>
              <GranularitySelect
                value={granularity}
                options={GRANULARITY_OPTIONS}
                resolvedLabel={granularityLabel}
                autoLabel={t("auto")}
                ariaLabel={t("granularity")}
                onChange={setGranularity}
              />
            </>
          )}
          {isZoomed && (
            <button
              type="button"
              className="lc-chip lc-chip--button lc-chip--active"
              onClick={resetZoom}
            >
              <Search aria-hidden="true" />
              {t("zoomedIn")}
              <X className="lc-chip__caret" aria-hidden="true" />
            </button>
          )}
        </div>

        {/* Counted off the raw days the API returned, so the figures describe
            the product rather than the resolution the chart is drawn at. */}
        {hasPlottedData && (
          <div className="lc-stats">
            <div className="lc-stat">
              <span className="lc-stat__value">{summary.totalCalls}</span>
              <span className="lc-stat__label">{t("totalCalls")}</span>
            </div>
            <div className="lc-stat">
              <span className="lc-stat__value">{summary.activeDays}</span>
              <span className="lc-stat__label">{t("activeDays")}</span>
            </div>
          </div>
        )}
      </div>

      <div className="graph-container">
        {isChartLoading && <div className="lc-skeleton" aria-hidden="true" />}

        {hasPlottedData && (
          <div className="lc-plot">
            <ResponsiveContainer height="100%" width="100%">
              {/* Still grouped bars - only what feeds them changed: contiguous
                  time buckets so the spacing is real, and palette colours that
                  stay with an employee between reloads. */}
              <BarChart
                data={data}
                accessibilityLayer
                margin={{ top: 16, right: 16, left: 0, bottom: 4 }}
                /* One bar per date, so the only gap that matters is between
                   dates - and with many dates on screen that gap is the
                   difference between a readable bar and a hairline, so it
                   tightens as the bars get thinner. */
                barCategoryGap={visibleCount > 60 ? "8%" : "30%"}
                /* Recharts re-renders the chart on every mouse move, throttled to 60fps
                   by default. A stacked chart with many bars does not need that rate to
                   feel responsive, and the spare frames matter in a dev build. */
                throttleDelay={80}
                onMouseDown={handleZoomStart}
                onMouseMove={handleZoomMove}
                onMouseUp={handleZoomEnd}
                onMouseLeave={handleZoomEnd}
                style={{ cursor: dragSelection ? "col-resize" : "crosshair" }}
              >
                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                <XAxis
                  dataKey="date"
                  tickLine={false}
                  tickMargin={8}
                  axisLine={false}
                  minTickGap={16}
                  interval="preserveStartEnd"
                />
                {/* The chart had no y axis at all, so a peak of 3 and a peak
                    of 300 looked identical. */}
                <YAxis
                  tickLine={false}
                  axisLine={false}
                  width={44}
                  allowDecimals={false}
                  tickMargin={4}
                >
                  <Label
                    value={t("calls")}
                    angle={-90}
                    position="insideLeft"
                    className="recharts-axis-label"
                    style={{ textAnchor: "middle" }}
                  />
                </YAxis>
                {/* While a drag is in progress the hover card is noise, and
                    recomputing it every frame is work the drag can do
                    without. */}
                <Tooltip
                  content={<LineChartTooltip />}
                  cursor={{ fill: isDark ? "#91A9BE" : "#1E293B", fillOpacity: 0.06 }}
                  active={dragSelection ? false : undefined}
                />
                {uniqueEmployees.map((employee) => (
                  <Bar
                    key={employee}
                    dataKey={employee}
                    name={employee}
                    hide={hiddenSeries.includes(employee)}
                    /* Stacked, so a date is a single bar whose height is the
                       calls logged that day and whose segments are who logged
                       them. */
                    stackId="calls"
                    /* A hairline in the surface colour separates one
                       employee's segment from the next without adding another
                       colour to read. */
                    stroke={surfaceColor}
                    strokeWidth={barStrokeWidth}
                    /* Flat segments: rounding each one turns a stack into a
                       column of pills and hides where one ends. */
                    radius={0}
                    /* Stops a single date stretching its bar across the whole
                       card. */
                    maxBarSize={44}
                    fill={employeeColors[employee]}
                    isAnimationActive={false}
                  />
                ))}

                {/* Shades the stretch being dragged over, so the selection is
                    visible before it is committed. */}
                {dragSelection && dragSelection.left !== dragSelection.right && (
                  <ReferenceArea
                    x1={dragSelection.left}
                    x2={dragSelection.right}
                    strokeOpacity={0}
                    fill={isDark ? "#91A9BE" : "#1E293B"}
                    fillOpacity={0.12}
                  />
                )}

                {/* The brush is what makes a daily range usable: 547 bars are
                    two pixels wide, so narrowing the window is the only way
                    to read them. */}
                {data.length > 2 && (
                  <Brush
                    dataKey="date"
                    height={24}
                    travellerWidth={8}
                    stroke={isDark ? "#91A9BE" : "#94A3B8"}
                    fill={isDark ? "#233C52" : "#F9FAFB"}
                    startIndex={zoomWindow ? zoomWindow.startIndex : undefined}
                    endIndex={zoomWindow ? zoomWindow.endIndex : undefined}
                    onChange={(range) => {
                      if (!range || range.startIndex == null) return;
                      if (range.endIndex > data.length - 1) return;
                      setZoom(windowFor(range.startIndex, range.endIndex));
                    }}
                  />
                )}
              </BarChart>
            </ResponsiveContainer>
          </div>
        )}

        {hasPlottedData && uniqueEmployees.length > 1 && (
          <LineChartLegend
            payload={legendPayload}
            hidden={hiddenSeries}
            onToggle={toggleSeries}
          />
        )}

        {!isChartLoading && data.length === 0 && (
          <div className="lc-empty">
            <span className="lc-empty__icon">
              <Package size={20} aria-hidden="true" />
            </span>
            <p className="lc-empty__title">{t("noCallsTitle")}</p>
            <p className="lc-empty__hint">{t("noCallsHint")}</p>
          </div>
        )}
      </div>
 </div>
    </div>
  );
}